export const preparingDataForRequest = (campusesList, details) => {
  const { filters, info, specificDetails } = details;

  const goals = filters && Array.isArray(filters.selectedList) && filters.selectedList.map(id => ({ externalAppointmentId: id }));
  const goalsDate = filters && filters.date;
  const runIn = info && info.runTime;
  const practitionerId = filters && filters.practitionerId;

  let locationsIds;
  if (filters.campusId) {
    const currentCampus = campusesList.find(({id}) => String(id) === String(filters.campusId));
    locationsIds = currentCampus && [currentCampus.id];
  } else {
    locationsIds = campusesList.map(({ id }) => id);
  }

  if (filters && info && specificDetails) {
    //──── Communicate ───────────────────────────────────────────────────────────────────────
    if (info.type === 'communicate') {
      return {
        practitionerId,
        locationsIds,
        runIn,
        emailSettings: {
          isActive: specificDetails.email,
          'subject': 'test subject',
          'body': 'test email'
        },
        smsSettings: {
          isActive: specificDetails.sms,
          message: specificDetails.smsMessage
        },
        pushSettings: {
          isActive: specificDetails.push,
          title: specificDetails.pushTitle,
          message: specificDetails.pushMessage
        },
        goals,
        goalsDate
      };
    }

    //──── Reschedule ────────────────────────────────────────────────────────────────────────
    if (info.type === 'reschedule') {
      return {
        practitionerId,
        locationsIds,
        runIn,
        rescheduleDate: specificDetails.rescheduleDate,
        appointmentTypeSettings: {
          type: specificDetails.appointmentType,
          typeId: specificDetails.appointmentTypeId
        },
        scheduleSettings: {
          type: specificDetails.schedule,
          scheduleId: specificDetails.scheduleId,
        },
        locationSettings: {
          type: specificDetails.locationType,
          locationsIds: specificDetails.locationsIds,
        },
        daySettings: {
          dayOfWeekType: specificDetails.daysOfWeekType,
          days: specificDetails.days,
          partOfDayType: specificDetails.partOfDayType,
          partsOfDay: specificDetails.partOfDay,
        },
        goals,
        goalsDate
      };
    }
  }
};